import { Injectable } from "@angular/core";
import { BaseFilter } from "../models/BaseFilter";

@Injectable()
export class SearchFilterBuilderService {
    
    build(filterOptions: BaseFilter, filterFields: any[]) {
        let filter = '';
    
        if (filterOptions) {
          if (filterOptions.value) {
            let operator = 'eq';
            if (filterOptions.field) {
              filter += filter ? '|' : '';
              filter += `${filterOptions.field};${operator};${filterOptions.value}`;
            } else {
              filterFields.forEach(o => {
                if (o.id) {
                  filter += filter ? '|' : '';
                  filter += `${o.id};${operator};${filterOptions.value}`;
                }
              });
            }
          }
    
          for (let [key, value] of Object.entries(filterOptions)) {
            if (value && key != 'field' && key != 'value') {
              let operator = 'eq';
              switch (key) {
                case 'startDate':
                  const startDate = new Date(value);
                  value = this.convertToUtc(startDate, '00:00:00');
                  operator = 'gteq';
                  break;
                case 'endDate':
                  const endDate = new Date(value);
                  value = this.convertToUtc(endDate, '23:59:59');
                  operator = 'lteq';
                  break;
              }
              filter += filter ? '|' : '';
              filter += `${key};${operator};${value}`
            }
          }
        }
    
        return filter;
    }

    convertToUtc(date: Date, time: string) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}T${time}.000Z`;
    }

    addDays(date: Date, days: number) {
      return this.addHours(date, days * 24);
    }
  
    addHours(date: Date, hours: number) {
      return new Date(new Date(date).getTime() + hours * 60 * 60 * 1000);
    }
}